import { ENV } from "../../config/runtimeEnv";
import type { UserUuid } from "../../types/identity";
import { http } from "../../lib/http/client";

const API_BASE_URL = ENV.VITE_HEALTHCARE_SERVER;

/** CU-14ygtkj98p4 (HI_015_006105): the explicit operator request; the server builds it from the saved patient record. */
export const requestCoreDemographicIhiRevalidation = async (patientId: UserUuid): Promise<unknown> => {
	const response = await http.post(`${API_BASE_URL}/practitioner/patient/${patientId}/ihi-revalidation`, {});
	return response.data?.data;
};

/** CU-14ygtkj98pb (HI_015_005815): the explicit operator address Search Type 6; the server builds it from the saved patient record. */
export const requestAddressIhiSearch = async (patientId: UserUuid): Promise<unknown> => {
	const response = await http.post(`${API_BASE_URL}/practitioner/patient/${patientId}/ihi-address-search`, {});
	return response.data?.data;
};
